/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileIfcShortcut = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M4 2h10.414L20 7.586V10h-2V9h-5V4H6v10H4zm11 3.414V7h1.586zM18 20v-1h2v3H8v-2z" />
        <path d="M12.386 17v-4.87h1.046V17zm1.996 0v-4.87h3.109v.884h-2.064v1.226h1.83v.884h-1.83V17zm7.412-1.065v.87a3.114 3.114 0 0 1-.61.202c-.227.058-.48.087-.757.087-.781 0-1.373-.221-1.775-.663-.402-.447-.603-1.088-.603-1.923 0-.514.098-.954.295-1.32a2.02 2.02 0 0 1 .837-.851c.362-.201.793-.302 1.293-.302.237 0 .456.025.657.074s.377.112.53.188v.884a4.16 4.16 0 0 0-.617-.188 2.407 2.407 0 0 0-.496-.053c-.46 0-.813.136-1.059.409-.245.272-.368.658-.368 1.159 0 .54.12.958.362 1.253.24.29.596.435 1.065.435.187 0 .377-.02.57-.06.196-.045.421-.112.676-.201zm-19.32 1.539L1 16h5v5l-1.653-1.653c-1.27.777-1.936 1.982.672 3.653 0 0-4.56-.436-3.298-4.29 0 0 .18-.576.753-1.236z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileIfcShortcut as FileIfcShortcut };
